import { unwrapResult } from '@reduxjs/toolkit'
import { Card, Col, message, Modal, Row, Table, Timeline } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import { useAppDispatch } from '../../app/hooks'
import { getDisposeStatementName, getRiskName } from '../../models/rule'
import { ThemeContext } from '../../theme/theme'
import { getProcessingDetailAsync } from './ProcessingDataSlice'
import styles from './ProcessingData.module.css'
import { CopyOutlined } from '@ant-design/icons'
import { ShowBox } from './ShowBox'
import moment from 'moment'
import { DateTimeFormat } from '../../models/datetime'

export const ProcessingDataModal = (props: {
  id?: any
  visible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const dispatch = useAppDispatch()

  const theme = useContext(ThemeContext)

  const [detail, setDetail] = useState<any>()

  const [processDetail, setProcessesDetail] = useState<any>()

  const copy = (e: any) => {
    const range = document.createRange()
    window.getSelection()?.removeAllRanges()
    range.selectNode(e.target)
    window.getSelection()?.addRange(range)
    const successful = document.execCommand('copy')
    if (successful) {
      message.success('复制成功')
    }
  }

  const copys = () => {
    var target: any = document.getElementById('text')?.innerText
    var input: any = document.getElementById('input')
    input.value = target
    input.select() // 选中文本
    const successful = document.execCommand('copy')
    if (successful) {
      message.success('复制成功')
    }
  }

  useEffect(() => {
    if (props.id) {
      dispatch(getProcessingDetailAsync(props.id))
        .then(unwrapResult)
        .then((d: any) => {
          setDetail(d)
          setProcessesDetail(d?.processes)
        })
        .catch(() => {
          // do nothing
        })
    } else {
      setDetail(undefined)
    }
  }, [dispatch, props.id])

  const labelStyle = {
    flex: '8rem',
    style: {
      color: theme.tc3,
      fontSize: '1rem',
      textAlign: 'right',
      marginBottom: 8,
    } as React.CSSProperties,
  }

  const valueStyle = {
    // flex: 1,
    style: {
      color: theme.tc1,
      fontSize: '1rem',
      marginBottom: 4,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    } as React.CSSProperties,
  }
  const valueStyles = {
    style: {
      color: theme.tc1,
      fontSize: '1rem',
      marginBottom: 4,
    } as React.CSSProperties,
  }

  return (
    <>
      <Modal
        className={styles.model}
        width={1200}
        title='执法数据详情'
        footer={null}
        visible={props.visible}
        onOk={() => {
          props.onOk()
        }}
        onCancel={() => {
          props.onCancel()
        }}
      >
        <Card size='small' title='预警详情' style={{ marginBottom: '10px' }}>
          <Row gutter={20}>
            <Col span={8}>
              <Row wrap={false}>
                <Col {...labelStyle}>预警ID：</Col>
                <Col {...valueStyle}>{detail?.cautionInfo?.cautionId}</Col>
              </Row>
            </Col>
            {/* <Col span={8}>
              <Row wrap={false}>
                <Col {...labelStyle}>主项编号：</Col>
                <Col {...valueStyle}>{detail?.cautionInfo?.ruleMainCode}</Col>
              </Row>
            </Col> */}
            <Col span={8}>
              <Row wrap={false}>
                <Col {...labelStyle}>预警条数：</Col>
                <Col {...valueStyle}>{detail?.cautionInfo?.cautionNum}</Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row>
                <Col {...labelStyle}>风险等级：</Col>
                <Col {...valueStyle}>
                  {getRiskName(detail?.cautionInfo?.cautionLevel)}
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row wrap={false}>
                <Col {...labelStyle}>上传时间：</Col>
                <Col {...valueStyle}>{detail?.cautionInfo?.uploadTime}</Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row wrap={false}>
                <Col {...labelStyle}>预警时间：</Col>
                <Col {...valueStyle}>{detail?.cautionInfo?.cautionTime}</Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row wrap={false}>
                <Col {...labelStyle}>上报卫健委(局)：</Col>
                <Col {...valueStyle}>{detail?.cautionInfo?.osName}</Col>
              </Row>
            </Col>

            <Col span={16}>
              <Row>
                <Col {...labelStyle}>预警机构：</Col>
                <Col {...valueStyle}>{detail?.cautionInfo?.orgName}</Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row wrap={false}>
                <Col {...labelStyle}>风险ID：</Col>
                <Col {...valueStyle} onClick={copy} id='text'>
                  {detail?.dataCode ? detail?.dataCode : '-'}{' '}
                </Col>
                <textarea className={styles.input} id='input'></textarea>
                <Col
                  onClick={copys}
                  style={{
                    marginLeft: '4px',
                    marginTop: '2px',
                    color: theme.tc3,
                  }}
                >
                  <CopyOutlined />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={20}>
            <Col span={24}>
              <Row wrap={false}>
                <Col {...labelStyle}>风险标题：</Col>
                <Col {...valueStyle}>
                  {detail?.cautionInfo?.cautionName || '-'}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={20}>
            <Col span={24}>
              <Row wrap={false}>
                <Col {...labelStyle}>风险描述：</Col>
                <Col {...valueStyles}>
                  {detail?.cautionInfo?.cautionContent}
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
        <Card size='small' title='执法结果' style={{ marginBottom: '10px' }}>
          <Row gutter={20}>
            <Col span={8}>
              <Row wrap={false}>
                <Col {...labelStyle}>处罚ID：</Col>
                <Col {...valueStyle}>{detail?.punishIds}</Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row wrap={false}>
                <Col {...labelStyle}>处理状态：</Col>
                <Col {...valueStyle}>
                  {/* {getDisposeStatusName(detail?.disposeStatus)} */}
                  {detail?.statusDesc}
                </Col>
              </Row>
            </Col>
            <Col span={8}>
              <Row wrap={false}>
                <Col {...labelStyle}>接收时间：</Col>
                <Col {...valueStyle}>{detail?.acceptTime}</Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={20}>
            <Col span={8}>
              <Row wrap={false}>
                <Col {...labelStyle}>处置时间：</Col>
                <Col {...valueStyle}>{detail?.disposeTime}</Col>
              </Row>
            </Col>
          </Row>
          <Row gutter={20}>
            <Col span={8}>
              <Row wrap={false}>
                <Col {...labelStyle}>处置结果：</Col>
                <Col {...valueStyle}>
                  {getDisposeStatementName(detail?.disposeStatement)}
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
        <Card size='small' title='执法过程' style={{ marginBottom: '10px' }}>
          {/*  <Table
            pagination={false}
            size='small'
            bordered
            dataSource={detail?.disposeRecords}
            rowKey={(t: any) => t.id}
            columns={[
              {
                title: '处置部门',
                dataIndex: 'deptName',
                align: 'center',
              },
              {
                title: '处置人员',
                dataIndex: 'disposePerson',
                align: 'center',
              },
              {
                title: '执法时间',
                dataIndex: 'disposeTime',
                align: 'center',
              },
              {
                title: '处置类型',
                dataIndex: 'disposeType',
                align: 'center',
                render: (_, r) =>
                  r.disposeType ? getDisposeResultName(r.disposeType) : '-',
              },
            ]}
          ></Table> */}

          <Timeline
            mode='left'
            style={{
              marginLeft: '-700px',
              marginTop: '10px',
              marginRight: '10px',
            }}
          >
            {processDetail &&
              processDetail?.map((v: any) => {
                const contentObj =
                  v[v.type.slice(0, 1).toLowerCase() + v.type.slice(1)]
                console.log(contentObj, 'contentObj')
                return (
                  <Timeline.Item
                    label={moment(v?.procTime).format(DateTimeFormat)}
                  >
                    <ShowBox type={v.type} processDetail={contentObj} />
                  </Timeline.Item>
                )
              })}
          </Timeline>
        </Card>
      </Modal>
    </>
  )
}
